import React from "react";
import { Restricted, permissions } from "components/auth";
import { AddAction } from "components/buttons";

const ActionButtons = () => (
  <Restricted permissions={[permissions.user_manage]}>
    <AddAction url={`/user/new`} />
  </Restricted>
);

export default ActionButtons;
